import { useState, useEffect } from 'react'
import { Table } from 'reactstrap'
import { deepCopy } from '../../utils.js'
import PubSub from 'pubsub-js'
import { FaCheckCircle } from 'react-icons/fa'


export default function DatapumpHistory(props) {
  console.log('DatapumpHistory rendered')

  const { source } = props
  const [jobList, setJobList] = useState([])

  function addJob(job) {
    const newJobList = jobList ? deepCopy(jobList) : []
    newJobList.push(job)
    setJobList(newJobList)
  }

  useEffect(() => {
    function handleDatapumpJobFinishedEvent(msg, data) {
      console.log(`EVENT RECEIVED (DatapumpHistory): ${msg}`, data)
      addJob(data)
    }
    const jobFinishedToken = PubSub.subscribe(`${source}_DATAPUMP_JOB_FINISHED`, handleDatapumpJobFinishedEvent)
    return function cleanup() {
      PubSub.unsubscribe(jobFinishedToken)
    }
  })

  const rows = []
  for (let job of jobList) {
    rows.push(
      <tr key={job.started}>
        <td><FaCheckCircle style={{ color: 'green', fontSize: '1.5em' }}/></td>
        <td>{job.operation}</td>
        <td>{job.schema.toUpperCase()}</td>
        <td>{job.started}</td>
        <td>{job.finished}</td>
        <td>{job.status}</td>
      </tr>
    )
  }

  if (jobList.length) {
    return ( 
      <Table bordered size="sm" style={{ width: 'auto', margin: 'auto', marginTop: '10px' }}>
        <thead>
          <tr><th colSpan={7}>Datapump Job History</th></tr>
          <tr>
            <th></th>
            <th>Operation</th>
            <th>Schema</th>
            <th>Started</th>
            <th>Finished</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </Table>
    )
  }
  return ''
}
